import React from 'react'
import { observer } from 'mobx-react'

function NotificationCircle ({ children, notifications, hide }) {
  const notificationClasses = [
    'bg-primary-500',
    'text-white',
    'text-2xs',
    'font-medium',
    'w-5',
    'h-5',
    'rounded-full',
    'flex',
    'items-center',
    'justify-center',
    'absolute',
    'top-0',
    'right-0',
    'transform',
    'translate-x-3',
    '-translate-y-3',
    'select-none',
    'cursor-pointer',
    hide ? 'hidden' : null
  ]

  return (
    <div className={notificationClasses.join(' ')}>
      {children || notifications}
    </div>
  )
}

export default NotificationCircle
